const BRANCH_OFFICE = [
  {
    name: "雨水市民の会役場",
    postal: "849-1112",
    address: "佐賀県杵島郡雨水市民の会福田1247-1",
    lat: 35.72114,
    lng: 139.81829
  }
];

export { BRANCH_OFFICE };
